import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { webSocketSubscriber } from '@/shared/api/web-socket-subscriber';

import { queryKeys } from '../api/merchant.queries';
import { merchantOnboardingCompletedNotificationSchema } from './merchant.schemas';

export function useMerchantOnboardingUpdates() {
    const queryClient = useQueryClient();

    useEffect(() => {
        const handler = () => {
            void queryClient.invalidateQueries({ queryKey: queryKeys.onboardingStatus() });
        };

        webSocketSubscriber.subscribe(merchantOnboardingCompletedNotificationSchema, handler);
        return () =>
            webSocketSubscriber.unsubscribe(merchantOnboardingCompletedNotificationSchema, handler);
    }, []);
}
